import { NavItems } from "./types";

export const navItems: NavItems[] = [
  {
    href: "/",
    label: "Dashboard",
  },
  {
    href: "/transactions",
    label: "Transactions",
  },
  {
    href: "/profile",
    label: "Profile",
  },
];
